import { UseTranslationResponse } from 'react-i18next';
import { TypeOptions } from 'i18next';
import type { ErrorTransformer } from '@rjsf/utils';
import { pullAt } from 'lodash';
import { JSONSchema7 } from 'json-schema';

export const transformErrors =
    (
        schemaType: string,
        schema: JSONSchema7,
        t: UseTranslationResponse<TypeOptions['defaultNS']>['t']
    ): ErrorTransformer =>
        (errors) => {
            if (schema.properties == null) {
                return errors;
            }
            let modifiedErrors = errors;
            const allBooleanFields = Object.keys(schema.properties)
                .filter(key => {
                    if (!schema.properties || typeof schema.properties[key] !== 'object') {
                        return false;
                    }

                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    return schema.properties[key].type === 'boolean'
                }) || [];
            const requiredBooleanFields = new Set(schema.required?.length ? allBooleanFields.filter(key => schema.required && schema.required.includes(key)) : []);

            if (requiredBooleanFields.size) {
                const toDelete: number[] = [];
                const toAddRequired: Map<string, any> = new Map();
                for (const [i, error] of modifiedErrors.entries()) {
                    if (requiredBooleanFields.has(error.property?.replace('.', '') || 'never.Field')) {
                        toDelete.push(i);
                        toAddRequired.set(error.property || 'never.Field', {...error, type: 'required', message: t('form.validation.required')});
                    }
                }
                if (toDelete.length) {
                    pullAt(modifiedErrors, toDelete);
                }
                if (toAddRequired.size) {
                    modifiedErrors.push(...toAddRequired.values());
                }
            }
            const startsWithAny = (text: string | undefined, samples: string[]) => {
                if (!text) {
                    return false;
                }
                return samples.some(sample => text.startsWith(sample));
            };

            const arrayFields = [
                '.currentRegions',
                '.nationalTargets',
                '.nationalProjects',
                '.implementationCountries'
            ];

            const requiredArrayFields = modifiedErrors.filter(error =>
                error?.name === 'type' && startsWithAny(error.property, arrayFields)
            );
            for (const regionError of requiredArrayFields) {
                regionError.message = t('form.validation.required') as string;
            }

            return modifiedErrors.filter(
                (error) => !(['const', 'oneOf'].includes(error.name as string) && startsWithAny(error.property, arrayFields))
            );
};
